export default __webpack_public_path__ + "static/media/Pricedown-Bl.6bea83af.woff";